'use client';

import { useRouter } from 'next/navigation';
import { ClipboardList, ChevronRight } from 'lucide-react';
import { clsx } from 'clsx';
import { useCart } from './cart-provider';

/**
 * In-Context-CTA im Beleg-Detail: erscheint, sobald die Anfrageliste (Draft)
 * Artikel enthält, und führt direkt zur Anfrageseite. Selbst-enthaltend — die
 * Anzahl kommt aus `useCart()`, bei leerer Liste rendert die Komponente nichts.
 * Wird im Mobile-Footer und in der Desktop-Aktionsleiste des Belegs eingebunden.
 *
 * `className` ist nur ein Layout-Haken (Breite/Abstand am Call-Site) — bewusst
 * keine Verhaltens-Varianten.
 */
export function RequestListBanner({ className }: { className?: string }) {
  const router = useRouter();
  const { itemCount } = useCart();

  if (itemCount === 0) return null;

  return (
    <button
      type="button"
      onClick={() => router.push('/materialanfrage')}
      className={clsx(
        'w-full flex items-center gap-3 px-3 py-2.5 rounded-xl bg-gray-100 hover:bg-gray-200/70 border border-gray-200 text-left transition-colors',
        className
      )}
    >
      <span className="relative shrink-0 text-primary">
        <ClipboardList size={22} />
        <span className="absolute -top-1.5 -right-1.5 min-w-[18px] h-[18px] px-1 flex items-center justify-center rounded-full bg-primary text-white text-[10px] font-bold leading-none">
          {itemCount}
        </span>
      </span>
      <span className="flex-1 min-w-0">
        <span className="block text-sm font-bold text-gray-600 leading-tight">
          Anfrageliste ansehen
        </span>
        <span className="block text-xs text-gray-500 leading-tight mt-0.5">
          {itemCount} Artikel bereit zum Anfragen
        </span>
      </span>
      <span className="flex items-center gap-0.5 text-sm font-bold text-primary shrink-0">
        Öffnen
        <ChevronRight size={16} />
      </span>
    </button>
  );
}
